import { DomainInfo } from '_backend/integration/domain-info';
import { Obfuscate } from '_components/common/Obfuscate/Obfuscate';
import { LayoutElementsProps } from '_components/layout/Layout';

import { getUrlHelper } from '../../utils';
import { ExpertiseList } from './ExpertiseList';

export const PostAProject = (props: LayoutElementsProps) => {
  const { t, navigationData, expertises, briefingCTA } = props;

  const domainInfo = DomainInfo.getFromOrigin(navigationData.origin);
  const locale = navigationData.locale;

  const getUrl = getUrlHelper(domainInfo, locale);

  const sortedExpertises = expertises?.sort((a, b) => a.name.localeCompare(b.name));

  const firstExpertises = sortedExpertises?.slice(0, (sortedExpertises?.length + 1) / 2);
  const secondExpertises = sortedExpertises?.slice((sortedExpertises?.length + 1) / 2, sortedExpertises?.length + 1);

  return (
    <div className="fadeIn layout-row">
      <div className="flex-45 layout-column px-4">
        <div className="py-4 px-2 flex-1 layout-column">
          <p className="h6 bold">{t('common:navbar.findAgencies.postAProject.letAgenciesComeToYou_V2')}</p>
          <p className="small text-secondary-500 mt-2">
            {t('common:navbar.findAgencies.postAProject.describeYourNeeds_V2')}
          </p>
          <ul className="small text-secondary-500 mt-4 pl-6 mb-0">
            <li className="pb-2">{t('common:navbar.findAgencies.postAProject.simpleQuickAgile')}</li>
            <li className="pb-2">{t('common:navbar.findAgencies.postAProject.completeAndUpToDate')}</li>
            <li className="pb-2">{t('common:navbar.findAgencies.postAProject.personalAssistance')}</li>
          </ul>
          <Obfuscate
            target="_blank"
            href={getUrl('project.new')}
            className="mt-2 text-underline small text-secondary-500"
            obfuscate={true}>
            {t('common:navbar.findAgencies.postAProject.learnMore')}
          </Obfuscate>
        </div>
        <div className="py-4 px-2">{briefingCTA}</div>
      </div>
      <div className="flex-1 layout-column px-4">
        <div
          data-testid="navbar-expertise-list"
          className="expertise-list bg-secondary-50 rounded-md layout-column px-2 flex-grow overflow-auto">
          <div className="px-4 pt-4">
            <p className="h6 bold text-secondary-900">{t('common:navbar.findAgencies.postAProject.postAProjectIn')}</p>
          </div>
          <div className="px-2 pb-2 flex-1 layout-column layout-align-start-stretch">
            <div className="layout-row mt-2">
              <div className="px-2 flex-1">
                <ExpertiseList expertises={firstExpertises} />
              </div>
              <div className="px-2 flex-1">
                <ExpertiseList expertises={secondExpertises} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
